import { render, staticRenderFns } from "./CompaniesWithoutLeadBoardsTable.vue?vue&type=template&id=7c429854&scoped=true&"
import script from "./CompaniesWithoutLeadBoardsTable.vue?vue&type=script&lang=js&"
export * from "./CompaniesWithoutLeadBoardsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c429854",
  null
  
)

export default component.exports